module.exports = __webpack_public_path__ + "img/7战略规划.152ee88c.png";